import { InsulationElement } from "./InsulationElement";
import { InsulationElementType } from "../../constants/combo/InsulationElementType";

export class FloorElement extends InsulationElement {
  getElementType = () => InsulationElementType.FLOOR;
  getMaxWidth = () => 50.0;
}
